import {
  FEATURE_FLAG_FALLBACK_NAMESPACE,
  FEATURE_FLAG_TIMEOUT,
} from './constants.js';

export const emptyFeaturesFallback = [];

const getFeaturesEndpoint = () => window.ENV_CONFIG.hosts.features_api;

export const loadFeatureFlags = async (
  namespace = FEATURE_FLAG_FALLBACK_NAMESPACE
) => {
  const headers = new Headers();

  headers.append('X-Hyble-Namespace', namespace);

  const request = new Request(getFeaturesEndpoint(), { headers });

  const response = await fetch(request, {
    signal: AbortSignal.timeout(FEATURE_FLAG_TIMEOUT),
  });

  const features = await response.json();

  window.FEATURES = Array.isArray(features)
    ? features.slice()
    : emptyFeaturesFallback;

  return features;
};
